import { render, staticRenderFns } from "./ValidarBodyModal.vue?vue&type=template&id=59f6c252&scoped=true&"
import script from "./ValidarBodyModal.vue?vue&type=script&lang=ts&"
export * from "./ValidarBodyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ValidarBodyModal.vue?vue&type=style&index=0&id=59f6c252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6c252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59f6c252', component.options)
    } else {
      api.reload('59f6c252', component.options)
    }
    module.hot.accept("./ValidarBodyModal.vue?vue&type=template&id=59f6c252&scoped=true&", function () {
      api.rerender('59f6c252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/ValidarBodyModal.vue"
export default component.exports